import React, { useRef, memo } from "react"
import PropTypes from "prop-types"
import GoogleMapReact from "google-map-react"
import { randomBytes } from "crypto"

const LocationsMap = ({ locationsState, lang = "de" }) => {
  const getDirections = require("../data/contact.json").mapLabel
  const getAddresses = require("../data/contact.json").addresses

  const cities = useRef(
    new Map([
      ["Berlin", [52.500267, 13.420325]],
      ["Shanghai", [31.21496, 121.450806]],
    ])
  )

  return (
    <GoogleMapReact
      key={randomBytes(6).toString("hex")}
      bootstrapURLKeys={{
        key: process.env.GOOGLE_MAPS_STATIC_API_KEY,
      }}
      defaultCenter={cities.current.get(locationsState)}
      defaultZoom={locationsState === "Berlin" ? 11 : 13}
      options={{
        zoomControl: false,
        fullscreenControl: false,
        styles: require("../maps/maps-styles.json"),
      }}
    >
      <div
        lat={cities.current.get(locationsState)[0]}
        lng={cities.current.get(locationsState)[1]}
        className="marker-wrapper"
      >
        <a
          href={`https://www.google.com/maps/search/?api=1&query=${getAddresses[locationsState]}`}
          target="_blank"
          no-referrer
        >
          {getDirections[lang]}
        </a>
        <div className="circle-marker"></div>
      </div>
    </GoogleMapReact>
  )
}

LocationsMap.propTypes = {
  locationsState: PropTypes.string,
}

export default memo(LocationsMap)
